import { render, staticRenderFns } from "./consents-config-settings.vue?vue&type=template&id=429aab49&"
import script from "./consents-config-settings.vue?vue&type=script&lang=ts&"
export * from "./consents-config-settings.vue?vue&type=script&lang=ts&"
import style0 from "./consents-config-settings.vue?vue&type=style&index=0&id=429aab49&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports